const createHeroBannerDesktopAnchorSeparator = () => {
    const wrapperDiv = document.createElement('div');
    wrapperDiv.classList.add('hbt-anchor-separator');
    wrapperDiv.setAttribute('role', 'presentation');

    return wrapperDiv;
};

const createHeroBannerDesktopAnchorLink = (id: string, title: string) => {
    const anchor = document.createElement('a');
    const anchorSpan = document.createElement('span');

    anchorSpan.classList.add('link-text');
    anchorSpan.innerText = title;

    anchor.classList.add('text-link', 'link-size-md', 'hbt-anchor');
    anchor.href = `#${id}`;
    anchor.appendChild(anchorSpan);

    return anchor;
};

const createHeroBannerMobileAnchorOption = (id: string, title: string) => {
    const opt = document.createElement('option');

    opt.value = id;
    opt.innerText = title;

    return opt;
};

const heroBannerAnchorInit = () => {
    const allAnchorTarget = document.querySelectorAll<HTMLButtonElement>(
        '[data-anchor-title]'
    );

    const desktopAnchors: HTMLElement[] = [];
    const mobileAnchorOptions: HTMLElement[] = [];

    allAnchorTarget.forEach((el: HTMLElement) => {
        const { id } = el;
        const title = el.dataset.anchorTitle;
        if (id && title) {
            const desktopAnchor = createHeroBannerDesktopAnchorLink(id, title);
            const desktopAnchorSeparator = createHeroBannerDesktopAnchorSeparator();
            desktopAnchors.push(desktopAnchorSeparator);
            desktopAnchors.push(desktopAnchor);

            const mobileAnchorOption = createHeroBannerMobileAnchorOption(id, title);
            mobileAnchorOptions.push(mobileAnchorOption);
        }
    });

    const anchorContainerDesktop = document.querySelectorAll<HTMLElement>('.hbt-anchors-container');
    const hrLine = document.querySelectorAll<HTMLElement>('.hbt-section-separator');

    if (desktopAnchors.length > 0) {
        anchorContainerDesktop.forEach((acd: HTMLElement) => {
            acd.append(...desktopAnchors);
        });
    } else {
        anchorContainerDesktop.forEach((acd: HTMLElement) => {
            acd.classList.add('no-page-anchor');
        });
        hrLine.forEach(line => {
            line.classList.add('no-page-anchor');
        });
    }

    if (mobileAnchorOptions.length > 0) {
        const anchorSelectMobile = document.querySelectorAll<HTMLElement>('#page-anchors');
        anchorSelectMobile.forEach((asm: HTMLElement) => {
            asm.append(...mobileAnchorOptions);
        });
    } else {
        const anchorContainerMobile = document.querySelectorAll<HTMLElement>('.hbt-mobile-anchors-container');
        anchorContainerMobile.forEach((acm: HTMLElement) => {
            acm.classList.add('no-page-anchor');
        });
    }
};

const heroBannerMobileAnchorHandle = () => {
    const anchorSelectMobile = document.querySelectorAll<HTMLElement>('#page-anchors');

    anchorSelectMobile.forEach((asm: HTMLElement) => {
        asm.addEventListener('change', event => {
            if (event.target && (event.target as HTMLInputElement).value) {
                const elmnt = document.getElementById((event.target as HTMLInputElement).value);
                if (elmnt) {
                    elmnt.scrollIntoView({ behavior: 'smooth', block: 'start', inline: 'start' });
                }
            }
        });
    });
};

document.addEventListener('DOMContentLoaded', () => {
    // check if we have hero banner text, and not Property hero banner:
    const heroBanner = document.querySelector('.hero-banner-block');
    if (!heroBanner) {
        return;
    }

    // check if anchor quick links is hidden
    const hideAnchor = document.querySelector('.hero-banner-text-content.hbt-anchors-hidden');
    if (hideAnchor) {
        const anchorContainerMobile = document.querySelectorAll<HTMLElement>('.hbt-mobile-anchors-container');
        anchorContainerMobile.forEach((acm: HTMLElement) => {
            acm.classList.add('no-page-anchor');
        });
    } else {
        heroBannerAnchorInit();
    }

    heroBannerMobileAnchorHandle();
});

// document.addEventListener('DOMContentLoaded', heroBannerMobileAnchorHandle);

// eslint-disable-next-line import/prefer-default-export
export { heroBannerAnchorInit };
